import "./user-team-leadership-contrast.css";

// Short Report: User vs Team - Leadership Contrast
// Unique classnames prefixed with tt-utlc- to avoid conflicts
const UserTeamLeadershipContrastReport = (comparisonResult) => {
  console.log(
    "UserTeamLeadershipContrastReport comparisonResult:",
    comparisonResult
  );
  const sr = comparisonResult?.comparisonData
    ?.userTeamLeadershipContrastShortReport ||
    comparisonResult?.userTeamLeadershipContrastShortReport || {
      team: {
        team_name: "FinOps",
        team_members: [
          {
            name: "John",
            leadership_score: 60,
            strengths: [],
            weaknesses: ["Strategic Vision", "Decision-Making"],
          },
          {
            name: "Maria",
            leadership_score: 70,
            strengths: ["Adaptability"],
            weaknesses: ["Decision-Making"],
          },
          {
            name: "David",
            leadership_score: 90,
            strengths: ["Communication", "Collaboration", "Decision-Making"],
            weaknesses: [],
          },
        ],
      },
      user: {
        user_name: "Alice Johnson",
        leadership_score: 75,
        strengths: ["Decision-Making", "Strategic Vision"],
        weaknesses: ["Collaboration"],
      },
      overview:
        "Alice is slightly above the team average. Her strengths (Decision-Making, Strategic Vision) map well to mentoring John (Decision-Making, Strategic Vision) and Maria (Decision-Making). For her growth area (Collaboration), David (90, Collaboration strength) is an ideal mentor. Consider a stretch lead assignment with Alice as decision owner, plus a Collaboration buddy-up with David.",
    };

  const teamName = sr?.team?.team_name ?? "Team";
  const userName = sr?.user?.user_name ?? "User";
  const userScore = Number(sr?.user?.leadership_score ?? 0);

  const teamMembers = Array.isArray(sr?.team?.team_members)
    ? sr.team.team_members
    : [];
  const teamScores = teamMembers.map((member) =>
    Number(member?.leadership_score ?? 0)
  );
  const avgTeamScore =
    teamScores.length > 0
      ? teamScores.reduce((a, b) => a + b, 0) / teamScores.length
      : 0;
  const minTeamScore = teamScores.length > 0 ? Math.min(...teamScores) : 0;
  const maxTeamScore = teamScores.length > 0 ? Math.max(...teamScores) : 0;
  const leadershipReadyCount = teamScores.filter((score) => score >= 75).length;

  return (
    <div className="tt-utlc-short-report-container">
      <div className="tt-utlc-report-header">
        <h3>Leadership Contrast</h3>
        <p>
          Leadership indicators comparison for mentoring and promotion
          opportunities
        </p>
      </div>

      {/* Metric Cards */}
      <div className="tt-utlc-comparison-summary">
        <div className="tt-utlc-summary-card">
          <div className="tt-utlc-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="tt-utlc-summary-content">
            <div className="tt-utlc-summary-value">
              {Math.round(
                comparisonResult.comparisonData.leadershipShortReport.userData
                  .leadershipScore
              )}
              %
            </div>
            <div className="tt-utlc-summary-label">Leadership score</div>
            <div className="tt-utlc-summary-label">
              {
                comparisonResult.comparisonData.leadershipShortReport.userData
                  .name
              }
            </div>
          </div>
        </div>

        <div className="tt-utlc-summary-card">
          <div className="tt-utlc-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="tt-utlc-summary-content">
            <div className="tt-utlc-summary-value">
              {Math.round(
                comparisonResult.comparisonData.leadershipShortReport.teamData
                  .avgLeadershipScore
              )}
              %
            </div>
            <div className="tt-utlc-summary-label">Average leadership</div>
            <div className="tt-utlc-summary-label">
              {
                comparisonResult.comparisonData.leadershipShortReport.teamData
                  .name
              }
            </div>
          </div>
        </div>

        <div className="tt-utlc-summary-card">
          <div className="tt-utlc-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-utlc-summary-content">
            <div className="tt-utlc-summary-value">
              {
                comparisonResult.comparisonData.leadershipShortReport.teamData
                  .leadershipReadyCount
              }
            </div>
            <div className="tt-utlc-summary-label">Leadership Ready</div>
            <div className="tt-utlc-summary-label">
              {
                comparisonResult.comparisonData.leadershipShortReport.teamData
                  .name
              }
            </div>
          </div>
        </div>
      </div>

      {/* Progress Bars */}
      <div className="tt-utlc-metrics-comparison">
        <h3>Leadership Score Comparison</h3>
        <div className="tt-utlc-metrics-chart">
          <div className="tt-utlc-metric-bar-container">
            <div className="tt-utlc-metric-info">
              <span className="tt-utlc-metric-name">
                {
                  comparisonResult.comparisonData.leadershipShortReport.userData
                    .name
                }
              </span>
            </div>
            <div className="tt-utlc-metric-bar">
              <div
                className="tt-utlc-metric-fill"
                style={{
                  width: `${Math.max(
                    0,
                    Math.min(
                      100,
                      Math.round(
                        comparisonResult.comparisonData.leadershipShortReport
                          .userData.leadershipScore
                      )
                    )
                  )}%`,
                }}
              ></div>
              <span className="tt-utlc-metric-value">
                {Math.round(
                  comparisonResult.comparisonData.leadershipShortReport.userData
                    .leadershipScore
                )}
              </span>
            </div>
          </div>

          <div className="tt-utlc-metric-bar-container">
            <div className="tt-utlc-metric-info">
              <span className="tt-utlc-metric-name">
                {
                  comparisonResult.comparisonData.leadershipShortReport.teamData
                    .name
                }
              </span>
              {/* <span className="tt-utlc-metric-range">
                Min {Math.round(minTeamScore)} | Max {Math.round(maxTeamScore)}
              </span> */}
            </div>
            <div className="tt-utlc-metric-bar">
              <div
                className="tt-utlc-metric-fill"
                style={{
                  width: `${Math.max(
                    0,
                    Math.min(
                      100,
                      Math.round(
                        comparisonResult.comparisonData.leadershipShortReport
                          .teamData.avgLeadershipScore
                      )
                    )
                  )}%`,
                }}
              ></div>
              <span className="tt-utlc-metric-value">
                {Math.round(
                  comparisonResult.comparisonData.leadershipShortReport.teamData
                    .avgLeadershipScore
                )}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="tt-utlc-insights-section">
        <h3>Analysis Overview</h3>
        <div className="tt-utlc-analysis-paragraph">
          <p>
            {comparisonResult.comparisonData.leadershipShortReport.overview}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserTeamLeadershipContrastReport;
